import * as React from 'react';
export const btcSvg = React.forwardRef(function btcSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#F7931A',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M23.053 13.72c.318-2.128-1.303-3.273-3.52-4.036l.72-2.884-1.756-.438-.7 2.808a73.436 73.436 0 0 0-1.406-.33l.705-2.827-1.755-.438-.72 2.883a58.729 58.729 0 0 1-1.12-.263l.002-.01-2.421-.604-.467 1.875s1.302.299 1.275.317c.71.178.84.648.818 1.021l-.82 3.286c.05.012.113.03.183.058l-.185-.046-1.148 4.603c-.087.216-.308.54-.805.417.018.025-1.276-.319-1.276-.319l-.871 2.01 2.284.57c.425.106.842.217 1.252.322l-.727 2.917 1.754.438.72-2.886c.478.13.943.25 1.398.363l-.717 2.872 1.756.438.726-2.912c2.994.567 5.245.338 6.192-2.37.764-2.18-.038-3.437-1.613-4.257 1.147-.264 2.011-1.019 2.242-2.577Zm-4.011 5.625c-.543 2.18-4.213 1.002-5.403.706l.964-3.864c1.19.297 5.006.885 4.439 3.158Zm.543-5.656c-.495 1.983-3.55.976-4.541.729l.874-3.505c.99.247 4.182.708 3.667 2.776Z',
      fill: '#fff',
    }),
  );
});
btcSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var btc = {
  category: 'brand',
  colorable: false,
  name: 'btc',
  svg: btcSvg,
};
